import Vue from "vue";
import { getParam } from "./entity/idb/getParam";
import { retailerConfig, util } from "./index";
/**
 * 基底コントローラクラス
 */
export abstract class baseVueController {

    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------
    /**
     * 編集ID
     */
    protected _editId: string;
    /**
     * 戻り先URL
     */
    protected _backUrl: string;
    /**
     * ログイン済みフラグ(true：ログイン済、false：未ログイン)
     */
    protected _loginFlg: boolean;
    /**
     * Vue.jsオブジェクト
     */
    protected _vue: Vue;
    /**
     * 設定ファイルオブジェクト
     */
    protected _retailerConfig: retailerConfig.retailerConfigEntity;
    /**
     * PCサイト？
     */
    protected _usePcDesign: boolean;

    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------
    /**
     * 編集ID
     */
    public get EditId(): string {
        return this._editId;
    }
    public set EditId(editId: string) {
        this._editId = editId;
    }

    /**
     * 戻り先URL
     */
    public get BackUrl(): string {
        return this._backUrl;
    }
    public set BackUrl(backUrl: string) {
        this._backUrl = backUrl;
    }

    /**
     * ログイン済みフラグ(true：ログイン済、false：未ログイン)
     */
    public get LoginFlg(): boolean {
        return this._loginFlg;
    }
    public set LoginFlg(loginFlg: boolean) {
        this._loginFlg = loginFlg;
    }

    /**
     * Vue.jsオブジェクト
     */
    public get Vue(): Vue {
        return this._vue;
    }
    public set Vue(vue: Vue) {
        this._vue = vue;
    }

    /**
     * リテーラ別設定情報
    */
    public get RetailerConfig(): retailerConfig.retailerConfigEntity {
        return this._retailerConfig;
    }
    public set RetailerConfig(retailerConfig: retailerConfig.retailerConfigEntity) {
        this._retailerConfig = retailerConfig;
    }

    /**
     * PCサイト？
     */
    public set UsePcDesign(usePcDesign: boolean) {
        this._usePcDesign = usePcDesign;
    }

    /**
     * 途中からフラグ取得
     */
    public getIsReturn(): boolean {

        // hiddenから途中フラグ取得
        let v = ($("#isReturn").val() + "").toLowerCase();
        if (v == "true") return true;
        return false;
    }

    /**
     * PC or SPフラグ
     */
    public getIsPC(): boolean {

        // hiddenから途中フラグ取得
        let v = ($("#isPC").val() + "").toLowerCase();
        if (v == "true") return true;
        return false;
    }

    /**
     * 再編集かフラグ
     */
    public getIsEdit(): boolean {

        // hiddenから途中フラグ取得
        let v = ($("#isEdit").val() + "").toLowerCase();
        if (v == "true") return true;
        return false;
    }

    /**
     * 追加注文かどうかフラグ
     * */
    public getIsAddOrder(): boolean {
        let v = ($("#isAddOrder").val() + "").toLowerCase();
        if (v == "true") return true;
        return false;
	}


    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------
    /**
     * コンストラクタ
     * */
    constructor() {
        this._editId = "";
        this._backUrl = "";
        this._loginFlg = false;
        this._vue = null;
    }

    /**
     * 初期処理メソッド
     * */
    public abstract init(): void;

    /**
     * リテーラ別の初期化処理
     * */
    public abstract initRetailer(): void;

    /**
     * エラー時の戻り先URL設定
     * */
    public SetErrorPageInfo(): void {
        // エラー時のボタン遷移先
        const that = this;
        if ($('#errorReturnTop')[0]) {
            $('#errorReturnTop').on('click', function () {
                window.location.href = that._retailerConfig.returnTop;
            });
        }
    }

    /**
     * ヘッダーの最初に戻るボタン押下メソッド
     * @param event
     */
    public btnClickReturnTop(event: JQueryEventObject): void {
        let getInfo = util.lstorage.get<getParam>(util.lstorage.KEY_GETPARAM, true);
        if (getInfo != null) {
            if (getInfo.returnUrl) {
                window.location.href = decodeURIComponent(getInfo.returnUrl);
                return;
            }
        }
        window.location.href = this._retailerConfig.returnTop;
    }

    /**
     * ヘッダーのお困りの方はこちらへボタン押下メソッド
     * @param event
     */
    public btnClickFaq(event: JQueryEventObject): void {
        util.ui.windowOpen(this._retailerConfig.faq.preview, "", null, null);
    }

    /**
     * ヘッダーの編集中一覧/注文履歴一覧ボタン押下メソッド
     * @param event
     */
    public btnClickOrderHistory(event: JQueryEventObject): void {
        window.location.href = this._retailerConfig.orderHistory;
    }

    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------
    /**
     * 前画面遷移ボタン押下メソッド
     * */
    public abstract btnClickReturnFlow(event: JQueryEventObject): void;

    /**
     * 次画面遷移ボタン押下メソッド
     * */
    public abstract btnClickNextFlow(event: JQueryEventObject): void;

}



